export default __webpack_public_path__ + "static/media/mt4-laptop.97a62ea5.png";